"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Button_1 = __importDefault(require("./Button"));
var ToogleButtons = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, className = _a.className, disabled = _a.disabled;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-toggle-buttons", disabled && 'disabled', className) }, options.map(function (o) { return (react_1.default.createElement(Button_1.default, { key: o.value, text: o.label, highlighted: value === o.value, variant: "secondary", onClick: function () { return onChange(o, o.value); }, disabled: disabled || o.disabled })); })));
};
exports.default = ToogleButtons;
